import React from 'react';
import { OnboardingForm } from './OnboardingForm';
import { Logo } from './Logo';
export function OnboardingPage() {
  return <div className="flex justify-center items-center min-h-screen bg-white" data-id="element-83">
      <div className="w-full max-w-[1200px] min-h-[250px] overflow-visible shadow-xl" data-id="element-84">
        <div className="w-full p-0 flex flex-col bg-white overflow-visible" data-id="element-85">
          <div className="mb-4 pl-4 pt-4 bg-white" data-id="element-86">
            <Logo data-id="element-87" />
          </div>
          <OnboardingForm data-id="element-88" />
        </div>
      </div>
    </div>;
}